// extracted by mini-css-extract-plugin
export default {"table-wrapper":"style_table-wrapper__W+taw","table":"style_table__4PITo","table-heading":"style_table-heading__Y-qhs","table-data":"style_table-data__zjfVT"};